import Header from "../Header";
import Footer from "../Footer";
import Breadcrumbs from "../Breadcrumbs";import BannerImg from "../assets/Images/banner-1920x450.png";

import BottomLogoImg from "../assets/Images/bottom-logo.png";
import LineImg from "../assets/Images/line.png";
import "./ArbitrationProcessPage.scss";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ArbitrationProcessPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <Header />
      <div className="banner">
        <img src={BannerImg} alt="" />
        <div className="banner_title res">
          <h1 className="banner-main-title">{t("arbitration_process_page_header")}</h1>
          <p className="banner-subtitle">{t("arbitration_process_page_header2")}</p>
        </div>
      </div>
      <Breadcrumbs>
        <Link>{t("breadcrumbs_arbitration_process_page_link1")}</Link>
        <span>{t("breadcrumbs_arbitration_process_page_span")}</span>
        <Link>{t("breadcrumbs_arbitration_process_page_link2")}</Link>
      </Breadcrumbs>
      <main className="process-main-container">
        <section className="process-content-section">
          <h2 className="process-section-title">{t("arbitration_process_page_h2")}</h2>
          <div className="process-image-container">
            <img src={t("arbitration_process_img1")} alt="Arbitration process diagram" className="process-image" />
          </div>
        </section>
        <div className="process-divider">
          <img src={LineImg} alt="Decorative line" className="divider-line" />
        </div>
      </main>
      <div className="temporary">
        <img src={BottomLogoImg} alt="" className="bottom-logo" />
      </div>

      <Footer />
    </>
  );
};

export default ArbitrationProcessPage;
